import React, { lazy, useEffect, useState, useContext, useMemo } from "react";
import { Accordion, AccordionTab } from "primereact/accordion";
import styled from "styled-components";
import { SLNotification, Spacer } from "../../components/core/utility";
import { css } from "@emotion/react";
import { DropdownSelect } from "@vds/selects";
import { CUSTOMER_INFORMATION_COL } from "../../constants/WorkTicketHistoryDetailsConstants";
import { C4SContext } from "../../context/c4sContext";
import { Dropdown } from "primereact/dropdown";
import "./dropdown.css";
import { getFullName, switchTab } from "./utils";
import { ERP_SUB_STATUS_DROPDOWN_VALUES } from "../../constants/C4SDecomConstants";

import _ from "lodash";
import { Loader } from "@vds/loaders";
import { getReturnTickets } from "../../services/C4S Decommission - Replacement/getReturnTickets";

import { generate } from "shortid";
import { getCSPDetails } from "../../services/C4S Decommission - Replacement/getCSPDetails";
import { updateNewrelicStats } from "../../../utility/newrelic";
import { updateReturnItem } from "../../services/C4S Decommission - Replacement/updateReturnItem";
import { getVinMaterialList } from "../../services/C4S Decommission - Replacement/getVinMaterialList";
import { addLostShipment } from "../../services/C4S Decommission - Replacement/addLostShipment";
import MigratedSchedulingData from "./MigratedSchedulingData";
import { hasPrivilege } from "../../../utility/privileges";
import { Privileges } from "../../../constants/PrivilegeConstants";
import useOutsideClick from "../../customHook/use-outside-click";

export const CustomisedInput = styled(Dropdown)`
  border: 0.0625rem solid #d8dada !important;
  border-bottom: 0.0625rem solid #000000 !important;
  width: 90%;
  height: 2.75rem;
  box-shadow: none !important;
  border-radius: 0;
  .p-inputtext,
  .p-button,
  .p-button:enabled:hover,
  .p-button:enabled:active,
  .p-dropdown:focus,
  .p-dropdown:active {
    font-size: 12px;
    font-family: Verizon-NHG-eTX;
    height: auto;
    margin: auto;
    position: relative;
    border: none;
    color: #000000 !important;
    background-color: transparent;
  }
`;

export const StyledCol = css`
  & div {
    @media screen and (min-width: 1260px) {
      // width: 99.5%;
      padding-right: 0.15em;
    }
  }
`;

export const CustomDropdown = styled(DropdownSelect)`
  & div {
    margin-bottom: ${(props) => (props.marginBottom ? props.marginBottom : "")};
    padding-right: ${(props) => (props.paddingRight ? props.paddingRight : "")};
    & label {
      & p {
        font-size: 12px;
        color: ${(props) => (props.disabled ? "#d8dada" : "")};
        & span {
          &::after {
            color: #747676;
          }
        }
      }
    }
  }
  }
  & select {
    font-size: 12px;
    color: ${(props) => (props.disabled || props.disableValue ? "#666b6b" : "")};
    &:disabled {
      -webkit-text-fill-color: #000000;
      background-color: #ffffff;
      border-bottom: 1px solid #000000;
      // color: ${(props) => (props.disabled || props.disableValue ? "#d8dada" : "")};
      opacity: ${(props) => (props.disabled ? "0.4" : "")};
    }
  }
`;

export const AccordionWrapper = styled.div`
  padding-top: 2.5rem;
  .p-accordion .p-accordion-tab .p-accordion-header .p-accordion-header-link,
  .p-accordion .p-accordion-tab .p-accordion-header:hover .p-accordion-header-link,
  .p-accordion .p-accordion-tab .p-accordion-header .p-accordion-header-link {
    color: #000000;
    border: none;
    padding: 0.5rem;
    background: #f6f6f6;
    box-shadow: unset;
    border-radius: unset;
  }

  .p-accordion .p-accordion-content {
    padding: 0rem;
    border: none;
  }
  .p-accordion-header-text {
    font-weight: 700;
    font-family: Verizon-NHG-eDS;
  }
`;

export default function WorkTicketHistoryItemTableWTA(props) {
  const [workTicketData, setWorkTicketData] = useState([]);
  // const returnTicketListdata = [];
  const [returnTicketList, setReturnTicketList] = useState([]);
  const [returnTicketError, setReturnTicketError] = useState(null);
  const [returnAccordianClickCount, setReturnAccordianClickCount] = useState(0);
  const [returnTicketModalData, setReturnTicketModalData] = useState({
    isShown: false,
    workTicketData: [],
    index: 0,
    type: "",
  });
  const [documentFlowData, setDocumentFlowData] = useState();
  let partialQtyMappedMMIDs = [];
  const [OneERPStatus, setOneERPStatus] = useState([]);
  const [OneERPSubStatus, setOneERPSubStatus] = useState([]);
  const [saveBtnDisabled, setSaveBtnDisabled] = useState(false);
  const [individualReturn, setIndividualReturn] = useState(false);
  const [migratedWT, setMigratedWT] = useState(props.data?.migratedRecord);
  const [erpStatusAccordianClickCount, setERPStatusAccordianClickCount] = useState(0);
  const [erpStatusAccordianError, setERPStatusAccordianError] = useState(null);
  const WTAddress =
    props?.data?.addressOne?.length > 0 ||
    props?.data?.addressTwo?.length > 0 ||
    props?.data?.city?.length > 0 ||
    props?.data?.stateCode?.length > 0 ||
    props?.data?.country?.length > 0 ||
    props?.data?.zipCode?.length > 0;
  const { isSourceCSP } = useContext(C4SContext);
  let cspCaseData = JSON.parse(sessionStorage.getItem("CSPDetails")),
    cspCaseOwner = "",
    crmReferenceId = "";
  let cspCaseDetails = {
    assignedTo: null,
    assignedToEmail: null,
    assignedToEid: null,
  };
  if (isSourceCSP.isSourceCSP) {
    cspCaseOwner = cspCaseData.CSP?.filter((cspData) => cspData.DefaultCSP === "1")[0]?.CSPOwner ?? "";
    crmReferenceId = cspCaseData.CSP?.filter((cspData) => cspData.DefaultCSP === "1")[0]?.CRM_Ref_ID ?? "";
    let cspData = cspCaseData.CSP.length ? cspCaseData.CSP.find((item) => item.DefaultCSP === "1") : {};
    cspCaseDetails = {
      assignedTo: cspData?.CSPOwner || null,
      assignedToEmail: cspData?.CSPOwnerEmail || null,
      assignedToEid: cspData?.CSPOwnerEId || null,
    };
  } else {
    cspCaseOwner = cspCaseData.CASEDetails?.filter((caseData) => caseData.DefaultCase === "1")[0]?.CaseOwner ?? "";
    crmReferenceId = cspCaseData.CASEDetails?.filter((caseData) => caseData.DefaultCase === "1")[0]?.CaseNumber ?? "";
    let caseData = cspCaseData.CASEDetails?.length ? cspCaseData.CASEDetails.find((item) => item.DefaultCase === "1") : {};
    cspCaseDetails = {
      assignedTo: caseData?.CaseOwner || null,
      assignedToEmail: caseData?.CaseOwnerEmail || null,
      assignedToEid: caseData?.CaseOwnerEId || null,
    };
  }
  const [address, setAddress] = useState({
    verified: false,
    addressByPass: null,
    locationFound: null,
    timezone: "",
    historicalAddress: { value: "", error: false, errorText: "", success: false },
    address1: { value: "", error: false, errorText: "Enter valid street address", success: false },
    address2: { value: "", error: false, errorText: "Enter address 2", success: false },
    city: { value: "", error: false, errorText: "Enter city", success: false },
    country: { value: null, options: [], error: false, errorText: "Please select country", success: false },
    state: { value: null, options: [], allStateOptions: null, error: false, errorText: "Please select state", success: false },
    zip: { value: "", error: false, errorText: "Enter zip code", success: false },
  });
  const handleClickOutside = () => {
    props.setNotification(null);
    setReturnTicketError(null);
    setERPStatusAccordianError(null);
  };

  const clickRef = useOutsideClick(handleClickOutside);
  const materialLineIdGenerator = function* (lineId = "000000") {
    while (true) {
      lineId = ("0000" + (+lineId + 10)).slice(-6);
      yield lineId;
    }
  };

  let limitWT = sessionStorage.getItem("limitWTCreation") == "true" ? true : false;
  let ERPStatus = props.data?.erpStatus;
  let ERPSubStatus = ERP_SUB_STATUS_DROPDOWN_VALUES.filter((record) => record.code === props.data?.subStatus)[0]?.description;
  const [selectedAssignedTo, setAssignedTo] = useState({ name: cspCaseOwner });
  const selectAssignedTo = [cspCaseOwner ? { name: cspCaseOwner } : ""];
  const [orderTrackingData, setOrderTrackingData] = useState();
  const [selectedERPStatus, setSelectedERPStatus] = useState(ERPStatus ? ERPStatus : "");
  const [selectedERPSubStatus, setSelectedERPSubStatus] = useState(props.data?.subStatus ? ERPSubStatus : "");
  const [originalDONumber, setOriginalDONumber] = useState({ value: "", error: true, errorText: "Enter Original Delivery Number" });
  const [transitModal, setTransitModal] = useState(false);
  const [partialShipmentLostModal, setPartialShipmentLostModal] = useState(false);
  const [partialTransitLostMMID, setPartialTransitLostMMID] = useState(null);
  const FULL_SHIPMENT_LOST = "Full Shipment - Lost in Transit";
  const PARTIAL_SHIPMENT_LOST = "Partial Shipment - Lost in Transit";
  const [isLoading, setLoader] = useState(false);
  // const [notification, setNotification] = useState(null);
  const [userName, setUsername] = useState("");
  const [vehicleInfoList, setVehicleInfoList] = useState([]);
  const [returnDeleteConfirmModal, setReturnDeleteConfirmModal] = useState(false);
  const [returnDeleteData, setReturnDeleteData] = useState(null);
  const [rtnReson, setReson] = useState(null);
  const [esitEsn, setEsitEsn] = useState([]);
  const [retnQty, setRetnQty] = useState(null);
  const [editReturnMaterialId, setEditReturnMaterialId] = useState(null);
  const [editReturnMaterialProcessingType, setEditReturnMaterialProcessingType] = useState(null);
  const [wareHouseNote, setWareHouseNote] = useState(props.data?.wareHouseNotes ? props.data?.wareHouseNotes : "");
  const [esnNote, setESNNote] = useState(props.data?.esnNotes ? props.data?.esnNotes : "");
  const [mmidDNNumber, setMMIDDNNumber] = useState([]);
  const [lineIdGenerator, setLineIdGenerator] = useState(materialLineIdGenerator);
  const [cspLoader, setCspLoader] = useState(false);
  const [returnTicketLoader, setReturnTicketLoader] = useState(false);
  const filteredWTMaterialList = props?.data?.materials?.filter((item) => item?.materialId?.startsWith("11"));
  const [defaultReturnType, setDefaultReturnType] = useState(null);
  const [editReturnData, setEditReturnData] = useState(null);

  // Create customer information rows array
  const customerInformationRows = useMemo(
    () => [
      {
        installType: props?.data?.installType || "--",
        contactName: props?.data?.contactName || "--",
        email: props?.data?.email || "--",
        phone: props?.data?.phone || "--",
        returnLabelName: props?.data?.returnLabelName || "--",
        returnLabelPhone: props?.data?.returnLabelPhone || "--",
        returnLabelEmail: props?.data?.returnLabelEmail || "--",
        shippingAddress:
          [props?.data?.addressOne, props?.data?.addressTwo, props?.data?.cityState, props?.data?.zipCode].filter(Boolean).join(", ") || "--",
      },
    ],
    [props?.data]
  );

  const [expandedRow, setExpandedRow] = useState([]);

  const TYPE_DROPDOWN = [
    { description: "Hardware accessory shipment", code: "ZHWA" },
    { description: "Mileage", code: "ZTML" },
    { description: "Customer Fee", code: "ZBTP" },
    { description: "Service-Misc", code: "ZSP1" },
    { description: "Service", code: "ZSPO" },
    { description: "Hardware shipment exchange", code: "ZZHS" },
    { description: "Hardware shipment", code: "ZHWS" },
    { description: "Hardware misc", code: "ZHS1" },
    { description: "Return Hardware", code: "ZZHR" },
    { description: "Return Accessories", code: "ZHAR" },
    { description: "Accessory Shipment Exchange", code: "ZZAE" },
  ];

  useEffect(() => {
    let initialCheck = !(limitWT || hasPrivilege(Privileges.ENABLE_WORKTICKET_PORTAL_READONLY));
    let fullShipment = selectedERPSubStatus === FULL_SHIPMENT_LOST;
    let fullLITCheck =
      selectedERPSubStatus === FULL_SHIPMENT_LOST &&
      originalDONumber?.value?.length > 0 &&
      mmidDNNumber.length > 0 &&
      mmidDNNumber.includes(originalDONumber?.value);
    let partialShipment = selectedERPSubStatus === PARTIAL_SHIPMENT_LOST;
    let addressFilled =
      address.address1.value?.length > 0 ||
      address.address2.value?.length > 0 ||
      address.city.value?.length > 0 ||
      address.zip.value?.length > 0 ||
      address.state.value?.length > 0 ||
      address.country.value?.code?.length > 0;
    let previousValueCheck =
      (selectedERPStatus ? selectedERPStatus === ERPStatus : true) &&
      (selectedERPSubStatus ? selectedERPSubStatus === ERPSubStatus : true) &&
      (wareHouseNote ? wareHouseNote === props.data?.wareHouseNotes : true) &&
      (esnNote ? esnNote === props.data?.esnNotes : true);
    if (initialCheck) {
      if (fullShipment || partialShipment) {
        if (fullShipment) {
          fullLITCheck
            ? filteredWTMaterialList?.length > 0 && vehicleInfoList?.length > 0
              ? migratedWT
                ? !WTAddress
                  ? address.verified
                    ? setSaveBtnDisabled(false)
                    : setSaveBtnDisabled(true)
                  : setSaveBtnDisabled(false)
                : setSaveBtnDisabled(false)
              : setSaveBtnDisabled(true)
            : setSaveBtnDisabled(true);
        }
        if (partialShipment) {
          filteredWTMaterialList?.length > 0 && vehicleInfoList?.length > 0
            ? migratedWT
              ? !WTAddress
                ? address.verified
                  ? setSaveBtnDisabled(false)
                  : setSaveBtnDisabled(true)
                : setSaveBtnDisabled(false)
              : setSaveBtnDisabled(false)
            : setSaveBtnDisabled(true);
          // if (migratedWT) {
          //   !WTAddress ? (address.verified ? setSaveBtnDisabled(false) : setSaveBtnDisabled(true)) : setSaveBtnDisabled(false);
          // } else {
          //   setSaveBtnDisabled(false);
          // }
          // migratedWT ? (address.verified ? setSaveBtnDisabled(false) : setSaveBtnDisabled(true)) : setSaveBtnDisabled(false);
        }
      } else {
        if (migratedWT) {
          !WTAddress
            ? addressFilled
              ? address.verified
                ? setSaveBtnDisabled(false)
                : setSaveBtnDisabled(true)
              : setSaveBtnDisabled(false)
            : setSaveBtnDisabled(false);
        } else {
          setSaveBtnDisabled(false);
        }
      }
    } else {
      setSaveBtnDisabled(true);
    }
    previousValueCheck && setSaveBtnDisabled(true);
  }, [
    selectedERPSubStatus,
    mmidDNNumber,
    originalDONumber?.value,
    address.verified,
    address.address1.value,
    address.address2.value,
    address.city.value,
    address.zip.value,
    address.state.value,
    address.country.value,
    selectedERPStatus,
    ERPStatus,
    ERPSubStatus,
    wareHouseNote,
    esnNote,
    vehicleInfoList,
  ]);

  useEffect(() => {
    setVehicleInfoList(props?.data?.vins);
    let deliveryDocNumber = [];
    let workTicketListData = props?.data?.materials?.map((material) => {
      if (material.deliveryDocNumber) {
        deliveryDocNumber.push(material.deliveryDocNumber);
      }
      return {
        id: material.id,
        MMID: material.materialId,
        itemDescription: material.materialName,
        type: material.processingCode,
        displayType: getFullName(TYPE_DROPDOWN, material.processingCode),
        contractItem: material.contractName,
        quantity: material.totalQty,
        MmidPgiDate: material.materialId + " - " + props?.data?.pgiDate,
        trackingNumbers: material.trackingNumbers,
        trackingUrls: material.trackingUrls,
        deliveryBlock: material.deliveryBlock,
        carriers: material.carriers,
        pgiDate: material.pgiDate,
        pgiQty: material.pgiQty,
        salesOrder: material.salesOrder,
        x_purchaseOrder: material.x_purchaseOrder,
        deliveryDocNumber: material.deliveryDocNumber,
        wtMaterialId: material.mid,
        contractId: material.cid,
        sapId: material.sapId,
        techRefId: material.techRefId,
        bundleId: material.bundleId,
        defaultReturnType: material.defaultReturnType,
        customerMaterialCharge: material.customerMaterialCharge,
        materialChargeCurrency: material.materialChargeCurrency,
        totalQty: material.totalQty,
      };
    });
    let deliveryDocNumberRecord = [...new Set(deliveryDocNumber.filter((record) => record))];
    deliveryDocNumberRecord.length
      ? setOriginalDONumber({ value: deliveryDocNumberRecord[0], error: false, errorText: "" })
      : setOriginalDONumber({ value: "", error: true, errorText: "Enter Original Delivery Number" });
    setMMIDDNNumber(deliveryDocNumberRecord);
    setWorkTicketData(workTicketListData);
    let documentData = {
      workTicketNumber: [1],
      salesOrder: [1],
      deliveryNumber: [0],
      purchaseOrder: [1],
      returnDelivery: [1],
    };
    setDocumentFlowData(documentData);
    // getReturnTicketList();
    if (
      sessionStorage &&
      JSON.parse(sessionStorage.getItem("Name")) === null &&
      (JSON.parse(sessionStorage.getItem("FirstName")) === null || JSON.parse(sessionStorage.getItem("LastName")) === null)
    ) {
      getCSpDetails();
    } else {
      let user =
        sessionStorage &&
        (JSON.parse(sessionStorage.getItem("Name")) ??
          JSON.parse(sessionStorage.getItem("FirstName")) + " " + JSON.parse(sessionStorage.getItem("LastName")));
      setUsername(user);
    }
    if (!isSourceCSP.isSourceCSP && workTicketData?.length) {
      const isIndividualReturn = workTicketData.some((ind) => ind.type === "ZZHR" || ind.type === "ZHAR");
      setIndividualReturn(isIndividualReturn);
    }
  }, [props]);

  useEffect(() => {
    let returnTicketWithCreatedStatus = returnTicketList.find((returnTicket) => returnTicket?.status?.toLowerCase() === "return_created");
    let lineIdGenerator;
    if (returnTicketWithCreatedStatus) {
      let initialMaterialLineId =
        returnTicketWithCreatedStatus.returnMaterial.length > 1
          ? returnTicketWithCreatedStatus.returnMaterial.reduce((e1, e2) =>
              e1.materialLineId > e2.materialLineId ? e1.materialLineId : e2.materialLineId
            )
          : returnTicketWithCreatedStatus.returnMaterial[0].materialLineId;
      lineIdGenerator = materialLineIdGenerator(initialMaterialLineId);
    } else {
      lineIdGenerator = materialLineIdGenerator();
    }
    setLineIdGenerator(lineIdGenerator);
  }, [returnTicketList]);

  useEffect(() => {
    setLoader(cspLoader || returnTicketLoader);
  }, [cspLoader, returnTicketLoader]);

  const getCSpDetails = async () => {
    setCspLoader(true);
    updateNewrelicStats();
    let cspData = await getCSPDetails(props?.AccountID, props?.ID, props?.userId);
    if (cspData.status === 200 && cspData?.data?.data) {
      let data = cspData.data.data;
      let user = `${data.firstName} ${data.lastName}`;
      sessionStorage.setItem("FirstName", JSON.stringify(data.firstName));
      sessionStorage.setItem("LastName", JSON.stringify(data.lastName));
      setUsername(user);
    } else {
      notify("Error fetching csp details", "error");
    }
    setCspLoader(false);
  };

  const getReturnTicketList = async () => {
    setReturnTicketLoader(true);
    setReturnAccordianClickCount(1);
    let workTicketId = props.data.ticketId;
    let response = await getReturnTickets(workTicketId);
    if (response?.status === 200 && response?.data) {
      let returnTickets = response.data.data;
      let returnTicketWithCreatedStatus = returnTickets.filter((returnTicket) => returnTicket?.status?.toLowerCase() === "return_created");
      setReturnTicketList(returnTickets);
      setExpandedRow(returnTicketWithCreatedStatus);
    } else {
      setReturnTicketError("Error while fetching the return tickets");
    }
    setReturnTicketLoader(false);
  };

  const notify = (content, type) => {
    props.setNotification(<SLNotification key={generate()} type={type} title={content} fullBleed={true} />);
  };

  useEffect(() => {
    let orderTrackingInfo = {
      plannedQuantity: [1],
      pgiDate: [1],
      selfInstalled: [0],
      installed: [1],
      returnedOrder: [1],
    };
    setOrderTrackingData(orderTrackingInfo);
  }, []);

  return (
    <>
      <Loader active={isLoading} fullscreen />
      <AccordionWrapper>
        <Accordion activeIndex={2} expandIcon="pi pi-chevron-down" collapseIcon="pi pi-chevron-up">
          <AccordionTab header="Customer Information">
            {/* Display customer information in two aligned rows */}
            <div style={{ display: "flex", flexDirection: "column", gap: "12px", marginBottom: "24px", marginTop: "10px", marginLeft: "3px" }}>
              {/* First row: columns 0-4 */}
              <div style={{ display: "grid", gridTemplateColumns: "repeat(5, 1fr)", gap: "16px" }}>
                {CUSTOMER_INFORMATION_COL.slice(0, 5).map((col) => (
                  <div key={col.value} style={{ display: "flex", flexDirection: "column" }}>
                    <div
                      style={{
                        fontWeight: 700,
                        fontSize: "12px",
                        lineHeight: "16px",
                        letterSpacing: "0px",
                        fontFamily: "Verizon NHG eTX, Helvetica, Arial, sans-serif",
                        marginBottom: "4px",
                        color: "#1E1E1E",
                      }}
                    >
                      {col.key}
                    </div>
                    <div
                      style={{
                        fontWeight: 400,
                        fontSize: "12px",
                        lineHeight: "16px",
                        letterSpacing: "0px",
                        fontFamily: "Verizon NHG eTX, Helvetica, Arial, sans-serif",
                        marginBottom: "4px",
                        color: "#1E1E1E",
                      }}
                    >
                      {customerInformationRows[0][col.value]}
                    </div>
                  </div>
                ))}
              </div>
              {/* Conditionally render second row */}
              {["return"].includes(String(props?.data?.workticketType).toLowerCase()) && (
                <div style={{ display: "grid", gridTemplateColumns: "repeat(5, 1fr)", gap: "16px" }}>
                  {CUSTOMER_INFORMATION_COL.slice(5, 8).map((col) => (
                    <div key={col.value} style={{ display: "flex", flexDirection: "column" }}>
                      <div
                        style={{
                          fontWeight: 700,
                          fontSize: "12px",
                          lineHeight: "16px",
                          letterSpacing: "0px",
                          fontFamily: "Verizon NHG eTX, Helvetica, Arial, sans-serif",
                          marginBottom: "4px",
                          color: "#1E1E1E",
                        }}
                      >
                        {col.key}
                      </div>
                      <div
                        style={{
                          fontWeight: 400,
                          fontSize: "12px",
                          lineHeight: "16px",
                          letterSpacing: "0px",
                          fontFamily: "Verizon NHG eTX, Helvetica, Arial, sans-serif",
                          marginBottom: "4px",
                          color: "#1E1E1E",
                        }}
                      >
                        {customerInformationRows[0][col.value]}
                      </div>
                    </div>
                  ))}
                  {/* Pad remaining columns for alignment */}
                  {Array.from({ length: 5 - CUSTOMER_INFORMATION_COL.slice(5, 8).length }).map((_, idx) => (
                    <div key={`empty-col-${idx}`} />
                  ))}
                </div>
              )}
            </div>
          </AccordionTab>
        </Accordion>
      </AccordionWrapper>
      <Spacer top="2rem" />
    </>
  );
}

export const WorkTicketHistoryItemTableWTAMetadata = {
  name: "Work View Item Table",
  id: "Work_View_Item_Table",
  component: lazy(() => import("./WorkTicketHistoryItemTableWTA")),
  route: "/work_view_item_table",
};
